(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acs-enquiry"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = () => {
    document.querySelectorAll('.acs-enquiry-form').forEach((form) => {
      if (form.dataset.acsValidationReady || !form.querySelector('[type="submit"]')) return;
      const summary = form.querySelector('[data-acs-validation-summary]');
      if (!summary) return;
      const list = summary.querySelector('ul');
      const fields = [...form.querySelectorAll('input:not([type="hidden"]), textarea')];
      const optional = ['acs-enquiry-business', 'acs-enquiry-phone', 'acs-enquiry-area', 'acs-enquiry-message'];
      optional.forEach((id) => {
        const field = form.querySelector(`#${id}`);
        if (field) field.required = false;
      });
      let attempted = false;
      const refresh = (focusSummary = false) => {
        list.replaceChildren();
        let count = 0;
        fields.forEach((field) => {
          const errorId = `${field.id}-error`;
          let error = form.querySelector(`#${errorId}`);
          field.setCustomValidity('');
          if (field.required && field.type !== 'checkbox' && !field.value.trim()) {
            field.setCustomValidity(field.dataset.acsMissing || field.dataset.acsInvalid);
          }
          if (field.tagName === 'TEXTAREA' && field.maxLength >= 0 && field.value.length > field.maxLength) {
            field.setCustomValidity(field.dataset.acsLength);
          }
          let message = '';
          if (!field.validity.valid) {
            if (field.validity.valueMissing || field.validity.customError) {
              message = field.validationMessage;
              if (field.validity.valueMissing) message = field.dataset.acsMissing;
            } else if (field.validity.typeMismatch) {
              message = field.dataset.acsInvalid;
            } else if (field.validity.tooLong) {
              message = field.dataset.acsLength;
            } else {
              message = field.dataset.acsInvalid || field.validationMessage;
            }
          }
          if (message) {
            if (!error) {
              error = document.createElement('p');
              error.id = errorId;
              error.className = 'acs-enquiry-field-error';
              const placement = field.type === 'checkbox' ? field.closest('.acs-enquiry-privacy') : field;
              placement.insertAdjacentElement('afterend', error);
              const describedBy = field.getAttribute('aria-describedby') || '';
              field.setAttribute('aria-describedby', `${describedBy} ${errorId}`.trim());
            }
            error.textContent = message;
            error.hidden = false;
            field.setAttribute('aria-invalid', 'true');
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = `#${field.id}`;
            link.textContent = message;
            link.addEventListener('click', (event) => {
              event.preventDefault();
              field.focus();
            });
            item.append(link);
            list.append(item);
            count += 1;
          } else {
            if (error) error.hidden = true;
            field.removeAttribute('aria-invalid');
          }
        });
        summary.hidden = count === 0;
        if (count && focusSummary) summary.focus();
        return count === 0;
      };
      form.addEventListener('submit', (event) => {
        attempted = true;
        if (!refresh(true)) event.preventDefault();
      });
      form.addEventListener('input', () => {
        if (attempted) refresh();
      });
      form.addEventListener('change', () => {
        if (attempted) refresh();
      });
      form.addEventListener('formdata', (event) => {
        optional.forEach((id) => {
          const field = form.querySelector(`#${id}`);
          if (field && !field.value.trim()) event.formData.delete(field.name);
        });
      });
      form.noValidate = true;
      form.dataset.acsValidationReady = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
